import React, { useEffect, useState } from 'react';
import FireFetch from "../../Firebase/FireFetch";
import { message, Form, Input, Select, Radio, DatePicker, Divider, Checkbox } from "antd";
import { Button } from "evergreen-ui";
import dayjs from 'dayjs';
import { MDBCol } from "mdbreact";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { useAuthState } from 'react-firebase-hooks/auth';
import { getDatabase, ref } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from "../../AuthContext/AuthContext";
import { isActiveUserStatus } from "../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";

const { TextArea } = Input;
var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
var storage = getStorage(Firebase);
const moment = require("moment");
const AddGroup = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateGroup = canAccessModule("GROUPS", "create");
	const [form] = Form.useForm();
	const [user] = useAuthState(auth);
	const [showLoading, setShowLoading] = useState(false);
	const [groups] = useListVals(ref(db, "talmidsdb/groups"));
	const [users] = useListVals(ref(db, "talmidsdb/users"));
	const [communityArray] = useListVals(ref(db, "talmidsdb/communities"));
	const [orgArray] = useListVals(ref(db, "talmidsdb/organisations"));
	const [languages] = useListVals(ref(db, "talmidsdb/languages"));
	const [groupTypes] = useListVals(ref(db, "talmidsdb/groupTypes"));
	const [radioValue, setRadioValue] = useState("No");
	const [userArray, setUserArray] = useState([]);
	const [districts] = useListVals(ref(db, "talmidsdb/district"));
	const [provinces] = useListVals(ref(db, "talmidsdb/province"));
	const [languageArray, setLanguageArray] = useState([]);
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));
	const [consents] = useListVals(ref(db, "talmidsdb/consents"));
	const [notListed, setNotListed] = useState(false);
	const [notListed2, setNotListed2] = useState(false);
	const marketDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	const [selectedType, setSelectedType] = useState();
	const [checkTypeList, setCheckTypeList] = useState([]);
	const [filesList, setFilesList] = useState([]);
	const [selectedProvinceId, setSelectedProvinceId] = useState(null);
	const ownConsents = (consents || []).filter((consent) => {
		const ownerId =
			consent.createdBy ||
			consent.addedByUser ||
			consent.submitedByuserID ||
			consent.submittedByUserID ||
			consent.userID ||
			consent.id;
		return ownerId === user?.uid;
	});

	useEffect(() => {
		const filteredOptions = groupTypes?.filter(x => x.id !== selectedType);
		filteredOptions?.map((item, index) => {
			filteredOptions[index]["label"] = item.type;
			filteredOptions[index]["value"] = item.id;
		});

		setCheckTypeList(filteredOptions ? [...filteredOptions] : []);
		if (users) {
			var tempUserArray = users;
			tempUserArray?.push({
				id: "Not Listed",
				firstname: "Not",
				surname: "Listed"
			});
			setUserArray(tempUserArray);
		}

		if (languages) {
			var tempLangArray = languages;
			tempLangArray.push({
				languageID: "Other",
				language: "Other"
			});
			setLanguageArray(tempLangArray);
		}

	}, [users, languages, user, groupTypes, selectedType])

	const onRadioChange = (e) => {
		setRadioValue(e.target.value);
	};

	const onChange = (checkedValues) => {
		console.log('checked = ', checkedValues);
	};

	const handleFileUpload = (e) => {
		const fileObject = {
			"fileID": e.target.id,
			"file": e.target.files[0]
		}
		if (!filesList.includes(fileObject)) {
			var index = filesList?.findIndex(x => x.fileID === fileObject.fileID);
			console.log(index);
			if (index != -1) {
				filesList.splice(index, 1);
				setFilesList(filesList => [...filesList, fileObject]);
			} else {
				setFilesList(filesList => [...filesList, fileObject]);
			}
		}
	}

	const communityChange = (option) => {
		var comm = communityArray?.find(x => x.id === option);
		var country = comm.countryID;
		var district = comm.district;
		form.setFieldsValue({
			country: country,
			district: district
		});
	}

	const addGroup = (values) => {
		if (!canCreateGroup) {
			message.error("You do not have permission to create groups.");
			return;
		}

		console.log(dayjs(values.yearEstablished));
		setShowLoading(true);
		var dateCreated = moment().format("YYYY-MM-DDTh:mm:ss");
		var dateModified = moment().format("YYYY-MM-DDTh:mm:ss");
		var groupID = uuidv4();
		var communityName = communityArray.find(x => x.communityID === values.community)?.name;
		var typeName = values?.groupType;
		var prefixName = communityName + "-" + typeName + "-" + values.genderDemographics;
		var filtered = groups?.filter(x => x.groupSelfName.includes(prefixName));
		var number = filtered.length + 1;
		var addedByUser = user.uid;
		var groupObject = values;
		groupObject.dateCreated = dateCreated;
		groupObject.dateModified = dateModified;
		groupObject.id = groupID;
		groupObject.yearEstablished = dayjs(values.yearEstablished).year();
		groupObject.addedByUser = addedByUser;
		groupObject.groupEndDate = values.groupEndDate ? values.groupEndDate.format("YYYY-MM-DD") : "";

		Object.entries(groupObject).forEach(([key, value]) => {
			if (value === undefined) {
				groupObject[key] = "";
			}
		});
		const output = FireFetch.SaveTODB("groups", groupID, groupObject);
		output.then((result) => {
			console.log(result);
			if (result === "success") {
				FireFetch.addLog("Groups", groupID, "Create");
				message.success("Group created successfully");
				var urlArray = [];
				filesList?.map((file, index) => {
					uploadBytes(storageRef(storage, `groups/${groupID}/image-${index}`), file.file).then((item) => {
						getDownloadURL(item.ref)
							.then((url) => {
								urlArray.push(url);
								console.log(urlArray);
								var picObj = { photos: urlArray };
								FireFetch.UpdateInDB("groups", groupID, picObj)
							});
					});
				})
				setShowLoading(false);
				form.resetFields();
				props.modal(false);
			}
		})
			.catch((error) => {
				message.error(`Unable to create group. An error occurred : ${error.message}`);
				setShowLoading(false);
			})
	}

	return (
		<>
			<MDBCol md={12}>
				<Form
					form={form}
					layout="vertical"
					onFinish={addGroup}
					initialValues={{
						groupStatus: "Active"
					}}
				>
					<Form.Item label="Organization"
						name="orgID"
						rules={[{
							required: true,
							message: 'Please select organisation!'
						}]}
					>
						<Select placeholder="Select group organisation"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{orgArray?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Consent" name="consentID">
						<Select
							placeholder="Select consent"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
						>
							{ownConsents.map((item, index) => (
								<Select.Option key={index} value={item.id}>
									{item.childrenNames || item.childrenName || item.fullName || item.id}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Community"
						name="communityID"
						rules={[{ required: true, message: 'Please input community!' }]}>
						<Select placeholder="Select group community"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
							onChange={communityChange}>
							{communityArray?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Country"
						name="countryID"
						rules={[{ required: true, message: 'Please input country!' }
						]}>
						<Select placeholder="select Country"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{countries?.map((item, index) => (
								<Select.Option value={item.id}>{item.countryName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Province"
						name="provinceID">
						<Select
							placeholder="Select Province"
							showSearch
							onChange={(value) => setSelectedProvinceId(value)}
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
						>
							{provinces?.map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.provinceName}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="District"
						name="districtID">
						<Select placeholder="Select District"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{districts
								?.filter(x => x.provinceID === selectedProvinceId)
								.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.districtName}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item label="Group Type"
						name="groupTypeId"
						rules={[{ required: true, message: 'Please input group type!' }]}>
						<Select placeholder="Select group type"
							showSearch
							onChange={setSelectedType}
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{groupTypes?.map((item, index) => (
								<Select.Option key={index} value={item?.id}>{item?.typeName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Secondary Group Activities" name={"secondaryGroupActivities"}>
						<Checkbox.Group options={checkTypeList} onChange={onChange} />
					</Form.Item>
					<Form.Item label="Gender Demographics"
						name="genderDemographics"
						rules={[{ required: true, message: 'Please select gender!' }]}>
						<Select placeholder="Select group gender demographics"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Male", "Female", "Mixed"].map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="What does the group call itself?"
						name="groupSelfName">
						<Input placeholder="enter what the group calls itself" id="groupSelfName" />
					</Form.Item>
					<Form.Item label="Responsible User"
						name="responsibleUserID"
						rules={[{
							required: true,
							message: 'Please select responsible user!'
						}]}
					>
						<Select placeholder="Select group's responsible User"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{users?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Year established"
						name="yearEstablished"
						rules={[{
							required: true,
							message: 'Please input year!'
						}]}>
						<DatePicker
							placeholder="select group's starting year"
							picker={"year"}
							className="w-100" />

					</Form.Item>
					<Form.Item
						label="Group End Date (If no longer active)"
						name="groupEndDate">
						<DatePicker
							placeholder="select group's end date"
							picker={"date"}
							className="w-100"
						/>
					</Form.Item>
					<Form.Item label="Group Primary Language" name="primaryLanguageID">
						<Select placeholder="Select group primary language"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{languageArray?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.languageName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Group Purpose Objective"
						name="groupPurposeObjective">
						<TextArea type="text"
							placeholder="enter group's purpose objective"
							className="w-100 mr-4"
							id="objective"
						/>
					</Form.Item>
					<Form.Item label="Active Men" name="activeMen"
						rules={[
							{
								//required: true,
								pattern: new RegExp(/\d+/),
								message: "Wrong number format!"
							}
						]}>
						<Input type="number" placeholder="enter number of active Men" />
					</Form.Item>
					<Form.Item label="Active Women" name="activeWomen"
						rules={[
							{
								//required: true,
								pattern: new RegExp(/\d+/),
								message: "Wrong number format!"
							}
						]}>
						<Input type="number" placeholder="enter number of active Women" />
					</Form.Item>
					<Form.Item label="Active Disabled" name="activeDisables"
						rules={[
							{
								//required: true,
								pattern: new RegExp(/\d+/),
								message: "Wrong number format!"
							}
						]}>
						<Input type="number" placeholder="enter number of active Disabled People" />
					</Form.Item>
					<Form.Item label="Group Meeting Days" name="groupMeetingDays">
						<Select placeholder="Select Meeting Day(s)"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{marketDays?.map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Has Completed ByLaws"
						name="hasCompletedByLaws">
						<Radio.Group onChange={onRadioChange} value={radioValue}>
							<Radio value={"No"}>No</Radio>
							<Radio value={"Yes"}>Yes</Radio>
						</Radio.Group>
					</Form.Item>
					<Form.Item label="Group Status"
						name="groupStatus"
						rules={[{
							required: true,
							message: 'Please select group status!'
						}]}
					>
						<Select placeholder="Select group status"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Active", "Inactive", "Terminated"].map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Market Day" name="marketDay">
						<Select placeholder="Select Market Day(s)"
							mode="multiple"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{marketDays?.map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Notes"
						name="notes">
						<TextArea type="text"
							placeholder="enter notes"
							className="w-100 mr-4"
							id="notes" />
					</Form.Item>
					<Form.Item
						label="Salesforce ID"
						name="salesforceID">
						<Input type="text"
							placeholder="enter Community SalesForce ID"
							className="w-100 mr-4"
							id="salesforce" />
					</Form.Item>
					<Divider orientation="left">
						Primary Contact Section
					</Divider>
					<Form.Item label="Primary Contact Name"
						name="primaryContactName"
						rules={[{
							required: true,
							message: 'Please select primary contact name!'
						}]}
					>
						{
							notListed ?
								<Input placeholder="enter primary contact name" id="primaryContact" />
								:
								<Select placeholder="Select group's primary contact"
									showSearch
									optionFilterProp="children"
									filterOption={filterSelectOption}
									filterSort={sortSelectOptions} onChange={(option) => {
										console.log(option)
										if (option === "Not Listed") {
											setNotListed(true);
											form.setFieldsValue({ primaryContactName: "" })
										} else {
											//setNotListed(false);
										}
									}}
								>
									{userArray.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
										<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
									))}
								</Select>
						}
					</Form.Item>
					<Form.Item label="Secondary Contact Name"
						name="secondaryContactName"
					>
						{
							notListed2 ?
								<Input placeholder="enter secondary contact name" id="secondaryContact" />
								:
								<Select placeholder="Select group's secondary contact"
									showSearch
									optionFilterProp="children"
									filterOption={filterSelectOption}
									filterSort={sortSelectOptions}
									onChange={(option) => {
										if (option === "Not Listed") {
											setNotListed2(true);
											form.setFieldsValue({ secondaryContactName: "" })
										} else {
											//setNotListed2(false);
										}
									}}
								>
									{userArray?.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
										<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
									))}
								</Select>
						}
					</Form.Item>
					<Form.Item
						label="Image 1"
						name="image1">
						<input
							type="file"
							accept="image/*"
							onChange={handleFileUpload}
						/>
					</Form.Item>
					<Form.Item
						label="Image 2"
						name="image2">
						<input
							type="file"
							accept="image/*"
							onChange={handleFileUpload}
						/>
					</Form.Item>
					<Button
						appearance="warning"
						onClick={() => props.modal(false)}
						disabled={showLoading}
					>
						Cancel
					</Button>
					<Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canCreateGroup}>
						Create
					</Button>
				</Form>
			</MDBCol>
		</>
	)
}

export default AddGroup;
